import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-react';

import {useTranslation} from 'react-i18next';
import {useInternationalization} from '@/contexts/InternationalizationContext';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import '@ckeditor/ckeditor5-build-classic/build/translations/fr';

const CONFIG = {
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'fontSize',
      'fontColor',
      'underline',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      '|',
      'indent',
      'outdent',
      '|',
      'imageUpload',
      'blockQuote',
      'insertTable',
      // 'mediaEmbed'
    ]
  },
  ckfinder: {
    uploadUrl: `${process.env.REACT_APP_BACKEND_URL}/ms-auth/api/files/ckeditor-image`
  },
  mediaEmbed: {
    previewsInData: true
  }
};

const Editor = ({value, onChange, placeholder, ...props}) => {
  const {t} = useTranslation('common');
  const {locale: language} = useInternationalization();

  const handleChange = useCallback((event, editor) => {
    const value = editor.getData();
    onChange({target: {value}});
  }, [onChange]);

  const config = useMemo(() => (
    {
      ...CONFIG,
      language,
      placeholder: placeholder || t('editorPlaceHolder'),
    }
  ), [language, placeholder, t]);

  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      config={config}
      onInit={editor => editor.setData(value)}
      onChange={handleChange}
      {...props}
    />
  );
};

export default memo(Editor);

Editor.defaultProps = {
  value: ''
};

Editor.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.any
};
